import { liquidSettleEvent } from '@/play/liquid/changes'
import { TINT_LIQUID } from '@/play/liquid/kind'

/** All the page's water is stained-glass ink, every colour alike (one density: no layering). */
export const WATER_KIND = TINT_LIQUID

/**
 * Water moving: a pour and everything it set running (one press, one undo step), or water running
 * into a dug channel (folded into the dig's own step).
 */
export const WATER_FLOW = liquidSettleEvent('experience.spill-again.flow', WATER_KIND)

/** Reducer handlers for this page (`experience.spill-again.*`). */
export const eventHandlers = WATER_FLOW.handlers
